/*
  Data structure of messages recieved by partner view.
 */ export var PartnersViewMessageType = /*#__PURE__*/ function(PartnersViewMessageType) {
    PartnersViewMessageType[PartnersViewMessageType["SetContext"] = 0] = "SetContext";
    PartnersViewMessageType[PartnersViewMessageType["ScrollChange"] = 1] = "ScrollChange";
    PartnersViewMessageType[PartnersViewMessageType["SizeChange"] = 2] = "SizeChange";
    return PartnersViewMessageType;
}({});
